import { Locale } from 'modules/i18n';

export const freemiumWelcomeDialogTranslation = {
  [Locale.en]: {
    description: `You're on the Freemium service plan. It provides a free monthly spending quota of 200M API Credits. You're all set to start API interaction.`,
    doneButton: 'Done',
    note: 'API quota bar may take ≤ 10 min to update after first request',
    title: 'Welcome to Web3 API',
  },
};
